import { IRequestOptions } from 'peekdata-datagateway-api-sdk';
import { BaseApi } from 'peekdata-datagateway-api-sdk/lib/api/base';
import { IReport } from 'src/models/report';

export class ReportsApi extends BaseApi {

  private reports = [{
    reportID: "e1",
    group: "Mortgage",
    title: "Loan amounts and property prices by countries, filtered by property type and closing date",
    created: null,
    modified: null,
    dataRequest: {
      requestID: "e1",
      consumerInfo: "Peekdata-Gateway-DataAPI-Demo",
      scopeName: "Mortgage-Lending",
      dataModelName: "Servicing-PostgreSQL",
      dimensions: ["cityname", "currency"],
      metrics: ["loanamount", "propertyprice"],
      filters: {},
      sortings: null,
      options: {
        rows: {
          "limitRowsTo": "10"
        },
        arguments: {},
        connections: {},
        security: {}
      }
    }
  }, {
    reportID: "e2",
    group: "Mortgage",
    title: "Loan amounts and WA Interest Rates by currencies, 2015—2017, capitals only",
    created: null,
    modified: null,
    dataRequest: {
      requestID: "e2",
      consumerInfo: "Peekdata-Gateway-DataAPI-Demo",
      scopeName: "Mortgage-Lending",
      dataModelName: "Servicing-PostgreSQL",
      dimensions: ["currency"],
      metrics: ["loanamount", "waintrate"],
      filters: {
        dateRanges: [{
          key: "approvaldate",
          from: "2015-01-01",
          to: "2017-12-31"
        }],
        singleKeys: [{
          key: "cityname",
          operation: "EQUALS",
          values: ["Warsaw", "Moscaw", "Grudzin"],
          type: "AUTO"
        }]
      },
      sortings: {
        dimensions: [{
          key: "currency",
          direction: "ASC"
        }]
      },
      options: {
        rows: {
          limitRowsTo: "100"
        },
        arguments: {},
        connections: {},
        security: {}
      }
    }
  }, {
    reportID: "e3",
    group: "Mortgage",
    title: "Top 3 Countries by Loan Amount",
    created: null,
    modified: null,
    dataRequest: {
      requestID: "e3",
      consumerInfo: "Peekdata-Gateway-DataAPI-Demo",
      scopeName: "Mortgage-Lending",
      dataModelName: "Servicing-PostgreSQL",
      dimensions: ["countryname", "currency"],
      metrics: ["loancount"],
      filters: {
        dateRanges: [{
          key: "approvaldate",
          from: "2016-01-01",
          to: "2017-12-31"
        }]
      },
      sortings: {
        metrics: [{
          key: "loancount",
          direction: "DESC"
        }]
      },
      options: {
        rows: {
          limitRowsTo: "3"
        },
        arguments: {},
        connections: {},
        security: {}
      }
    }
  }];

  /**
   * Gets report
   */
  public getReport = (sessionID: string, reportID: string, requestOptions?: IRequestOptions) => {
    return this.reports.find(report => report.reportID === reportID);
  }

  /**
   * Gets all reports
   */
  public getReportsList = (sessionID: string, requestOptions?: IRequestOptions) => {


    return this.reports;
  }

  /**
   * Creates report or updates existing one
   */
  public saveReport = (sessionID: string, body: IReport, requestOptions?: IRequestOptions) => {
    return this.post<IReport, IReport>({
      path: '/report/save',
      params: [
        { key: 'sessionID', value: sessionID },
      ],
      body,
      requestOptions,
    });
  }

  /**
   * Removes report
   */
  public removeReport = (sessionID: string, reportID: string, requestOptions?: IRequestOptions) => {
    return this.post<void>({
      path: '/report/delete',
      params: [
        { key: 'sessionID', value: sessionID },
        { key: 'reportID', value: reportID },
      ],
      requestOptions,
    });
  }
}
